import { useMemo } from "react";

import { Box, FilterMultiSelect, type FilterPillOption } from "@hightouch/htui";

import { getResourceTypeOptions } from "./resource-display";
import { toTypeSelection, type TypeSelection } from "./usage-tree-state";

type Props = {
  countsByType: ReadonlyMap<string, number>;
  selectedTypes: TypeSelection;
  onChange: (selectedTypes: TypeSelection) => void;
};

export function ResourceTypeFilter({
  countsByType,
  selectedTypes,
  onChange,
}: Props) {
  const options = useMemo<FilterPillOption<string>[]>(
    () =>
      getResourceTypeOptions(countsByType).map(({ value, label, count }) => ({
        value,
        label,
        badge: count.toLocaleString(),
      })),
    [countsByType],
  );

  if (options.length === 0) {
    return null;
  }

  return (
    <Box flex={1}>
      <FilterMultiSelect
        label="Resource types"
        width="100%"
        options={options}
        value={
          new Set(
            selectedTypes === "all"
              ? options.map((option) => option.value)
              : selectedTypes,
          )
        }
        onChange={(next) => onChange(toTypeSelection(next, options))}
      />
    </Box>
  );
}
